import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('pricing_countdown_end') : null;
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    const end = Date.now() + 24 * 60 * 60 * 1000;
    if (typeof window !== 'undefined') localStorage.setItem('pricing_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const cuposPercentage = 71;
  return <section className="w-full bg-[#FBF5EC] donut-pattern py-4 md:py-8" data-id="element-171">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-173">
          <div className="text-center mb-3 md:mb-5" data-id="element-174">
            <div className="bg-[#FDF2EC] border border-[#E5C9B0] rounded-2xl p-4 md:p-6 max-w-3xl mx-auto shadow-sm" data-id="element-175">
              <h2 className="text-2xl md:text-4xl font-bold text-[#3D2817] mb-3 md:mb-4" data-id="element-176">
                ⏰ PRECIO DE LANZAMIENTO — OFERTA LIMITADA
              </h2>

              <div className="flex items-center justify-center gap-2 md:gap-4 mb-3 md:mb-4" data-id="element-177">
                {[{
                value: pad(hours),
                label: 'HS'
              }, {
                value: pad(minutes),
                label: 'MIN'
              }, {
                value: pad(seconds),
                label: 'SEG'
              }].map((unit, index) => <Fragment key={unit.label} data-id="element-178">
                    {index > 0 && <span className="text-4xl md:text-7xl font-bold text-[#B85450] -mt-4 md:-mt-6" data-id="element-179">
                        :
                      </span>}
                    <div className="flex flex-col items-center" data-id="element-180">
                      <motion.span key={unit.value} initial={{
                    scale: 1.1,
                    opacity: 0.7
                  }} animate={{
                    scale: 1,
                    opacity: 1
                  }} transition={{
                    duration: 0.2
                  }} className="text-5xl md:text-8xl font-bold text-[#B85450] tabular-nums leading-none" data-id="element-181">
                        {unit.value}
                      </motion.span>
                      <span className="text-xs md:text-sm text-[#9B8770] font-medium mt-1 tracking-widest" data-id="element-182">
                        {unit.label}
                      </span>
                    </div>
                  </Fragment>)}
              </div>

              <div className="flex items-center justify-center gap-2 text-[#3D2817] mb-3 md:mb-4" data-id="element-183">
                <span className="text-lg md:text-xl" data-id="element-184">⚠️</span>
                <p className="text-sm md:text-base font-semibold" data-id="element-185">
                  Este precio no se va a mantener. Una vez que se agoten los
                  cupos de lanzamiento, el precio sube a $54.960 ARS. No vuelve
                  atrás.
                </p>
              </div>

              <div className="max-w-xl mx-auto" data-id="element-186">
                <div className="flex items-center justify-between mb-1" data-id="element-187">
                  <div className="flex items-center gap-2" data-id="element-188">
                    <span className="w-2 h-2 rounded-full bg-[#B85450] animate-pulse" data-id="element-189"></span>
                    <span className="text-sm text-[#B85450] font-medium" data-id="element-190">
                      Cupos al precio de lanzamiento
                    </span>
                  </div>
                  <span className="text-sm text-[#6B5747] font-bold" data-id="element-191">
                    Quedan pocos
                  </span>
                </div>
                <div className="w-full h-3 bg-[#F0E3CE] rounded-full overflow-hidden" data-id="element-192">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${cuposPercentage}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  ease: 'easeOut'
                }} className="h-full rounded-full" style={{
                  background: 'linear-gradient(90deg, #B85450 0%, #B45309 70%, #D4A373 100%)'
                }} data-id="element-193" />
                </div>
                <p className="text-xs text-[#9B8770] mt-1 text-right" data-id="element-194">
                  {cuposPercentage}% de los cupos ya tomados
                </p>
              </div>
            </div>
          </div>

          <h3 id="elegi-tu-pack" className="text-2xl md:text-3xl font-bold text-[#3D2817] text-center mb-3 md:mb-5 scroll-mt-8" data-id="element-195">
            💳 TU ACCESO COMPLETO
          </h3>

          <div className="max-w-2xl mx-auto" data-id="element-196">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-gradient-to-b from-white to-[#FBF5EC] border-2 border-[#B8855C] rounded-lg p-5 md:p-6 relative shadow-md" data-id="element-197">
              <h4 className="text-xl font-bold text-[#3D2817] mb-1" data-id="element-198">
                🕯️ MEGA PACK EL MÉTODO MAESTRO
              </h4>
              <p className="text-[#7A4A2B] font-semibold mb-1 text-sm" data-id="element-199">
                Sahumerios de Alta Rentabilidad
              </p>
              <p className="text-[#B45309] font-semibold mb-2 text-sm" data-id="element-200">
                3 Tomos + 2 Bonos — Masa → Negocio en Pesos
              </p>
              <p className="text-[#6B5747] text-sm mb-3" data-id="element-201">
                Ideal para cualquier persona que quiera emprender con sahumerios
                desde casa, sin experiencia previa
              </p>

              {/* Value stack — anchors the price by breaking down what's inside */}
              <div className="bg-[#FBF5EC] border border-[#E8D5BA] rounded-lg p-3 mb-3" data-id="element-202">
                <p className="text-xs font-bold text-[#3D2817] tracking-wider mb-2" data-id="element-203">
                  📦 LO QUE TE LLEVÁS HOY:
                </p>
                <div className="space-y-1 text-sm" data-id="element-204">
                  <div className="flex justify-between items-center" data-id="element-205">
                    <span className="text-[#6B5747]" data-id="element-206">
                      Tomo 1 — La Ingeniería de la Masa
                    </span>
                    <span className="text-[#9B8770] line-through" data-id="element-207">$14.990</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-208">
                    <span className="text-[#6B5747]" data-id="element-209">
                      Tomo 2 — Alquimia y Aromaterapia
                    </span>
                    <span className="text-[#9B8770] line-through" data-id="element-210">$14.990</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-211">
                    <span className="text-[#6B5747]" data-id="element-212">
                      Tomo 3 — Negocio y Ventas 2026
                    </span>
                    <span className="text-[#9B8770] line-through" data-id="element-213">$14.990</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-214">
                    <span className="text-[#6B5747]" data-id="element-215">
                      🎁 Bono 1 — Reto de los 30 Días
                    </span>
                    <span className="text-[#5C8A6D] font-semibold" data-id="element-216">GRATIS</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-217">
                    <span className="text-[#6B5747]" data-id="element-218">
                      🎁 Bono 2 — Manual de Seguridad y Calidad
                    </span>
                    <span className="text-[#5C8A6D] font-semibold" data-id="element-219">GRATIS</span>
                  </div>
                </div>
                <div className="border-t border-[#E8D5BA] mt-2 pt-2 flex justify-between items-center" data-id="element-220">
                  <span className="text-[#3D2817] font-bold text-sm" data-id="element-221">
                    Valor real total
                  </span>
                  <span className="text-[#3D2817] font-bold text-base line-through" data-id="element-222">
                    $54.960
                  </span>
                </div>
              </div>

              <div className="mb-3" data-id="element-223">
                <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-224">
                  <span className="text-[#9B8770] line-through text-xl font-medium" data-id="element-225">
                    $54.960
                  </span>
                  <span className="bg-[#B85450] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-226">
                    -76% OFF
                  </span>
                </div>
                <div className="flex items-baseline gap-2" data-id="element-227">
                  <span className="text-[#B45309] font-bold text-4xl md:text-5xl" data-id="element-228">
                    $12.990
                  </span>
                  <span className="text-[#9B8770] text-sm" data-id="element-229">ARS</span>
                </div>
                <p className="text-[#5C8A6D] font-semibold text-sm mt-1" data-id="element-230">
                  ✅ Ahorrás $41.970 hoy
                </p>
                <p className="text-[#7A4A2B] font-medium text-xs mt-0.5" data-id="element-231">
                  + Bonos por $27.980 incluidos GRATIS
                </p>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48321691189440:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-[#B45309] hover:bg-[#92400E] text-white font-bold text-lg px-6 py-3.5 rounded-lg transition-colors shadow-lg shadow-[#7A4A2B]/30 text-center" data-id="element-232">
                🔴 → QUIERO MI MEGA PACK AHORA
              </motion.a>

              <motion.a href="https://wa.me/543516347235?text=Hola!!%20Tuve%20un%20problema%20con%20Mercado%20Pago%20al%20comprar%20El%20Método%20Maestro..%20Gracias!!" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="mt-2 flex items-center justify-center gap-2 w-full bg-white hover:bg-[#F0FAF3] border-2 border-[#25D366] text-[#1ebe5b] font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors text-center" data-id="element-233">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-234">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-235" />
                </svg>
                ¿Tuviste un problema con Mercado Pago? Escribinos
              </motion.a>

              <div className="mt-2 text-center text-xs text-[#9B8770]" data-id="element-236">
                ⭐ Pago 100% seguro · Acceso en 5 minutos · Garantía 7 días
                <br data-id="element-237" />
                Mercado Pago · Tarjeta · Transferencia
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}